// extracted by mini-css-extract-plugin
export default {"root":"CustomerDetails_root__KkH+o"};